import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import LoadingContext from "../../../../ui/components/LoadingContext/LoadingContext";
import Message from "../../../../ui/components/Messages/Message";
import Table from "../../../../ui/components/Table/Table";

import useAutoApprovalRules from "../../../hooks/useAutoApprovalRules";

import useAutoApprovalRulesColumns from "../hooks/useAutoApprovalRulesColumns";

import AddAutoApprovalRule from "./AddAutoApprovalRule";

export default function AutoApprovalRules({ organization }) {
	const { t } = useTranslation();

	const [autoApprovalRules, loading, error] = useAutoApprovalRules(organization);

	const autoApprovalRulesColumns = useAutoApprovalRulesColumns(organization);

	return (
		<>
			<Header as="h3">{t("autoApprovalRules", "Auto-approval rules")}</Header>

			<Card fluid>
				<Card.Content>
					<Message>
						{t("autoApprovalRulesMessage", "Any prices below the threshold will be auto-approved")}
					</Message>

					<LoadingContext data={autoApprovalRules} loading={loading} error={error}>
						<Table
							data={autoApprovalRules}
							columns={autoApprovalRulesColumns}
							footer={false}
							style={{ marginTop: 10 }}
						/>
					</LoadingContext>
				</Card.Content>

				<Card.Content>
					<>
						<AddAutoApprovalRule organization={organization} />
					</>
				</Card.Content>
			</Card>
		</>
	);
}
